import HTTP from './index';

export const loginUser = (credentials, recaptchaToken) => HTTP.post("/login", credentials,{ headers: { "Recaptcha-Token": recaptchaToken }});
// export const loginUser = (credentials) => HTTP.post("/login", credentials);
